import { Delivery, Home } from "@carbon/icons-react";
import { TFunction } from "i18next";
import { PlusCircle } from "react-feather";

import { SidebarItemsType } from "../../models/sidebar";

const getSection = (t: TFunction) =>
  [
    {
      href: "/home",
      icon: <Home size={24} />,
      title: t("home"),
    },
    {
      href: "/deliveries",
      icon: <Delivery size={24} />,
      title: t("deliveries"),
    },
    {
      href: "/newOrder",
      icon: <PlusCircle size={24} />,
      title: t("newOrder"),
    },
    /* {
      href: "/",
      icon: <OverflowMenuHorizontal size={24} />,
      title: t("more"),
      children: [
        {
          href: "/",
          icon: <PenFountain size={16} />,
          title: t("Placeholder"),
        },
      ],
    }, */
  ] as SidebarItemsType[];

const getNavItems = (t: TFunction) => [
  {
    title: "",
    pages: getSection(t),
  },
];

export default getNavItems;
